export const visionOptions = [
    {
        value: "faith",
        label: "Faith"
    },
    {
        value: "family",
        label: "Family"
    },
    {
        value: "sports",
        label: "Sports"
    },
    {
        value: "school",
        label: "School"
    },
    {
        value: "arts_music",
        label: "Arts & Music"
    },
    {
        value: "travel",
        label: "Travel"
    },
    {
        value: "hobbies",
        label: "Hobbies"
    },
    {
        value: "service",
        label: "Service"
    },
    {
        value: "work",
        label: "Work"
    },
    {
        value: "relationships",
        label: "Relationships"
    },
    {
        value: "justice",
        label: "Justice"
    },
    {
        value: "other",
        label: "Other"
    }
]; 